/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as authRouteRouteImport } from './routes/(auth)/route'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as authForgotPasswordRouteImport } from './routes/(auth)/forgot-password'
import { Route as authResetPasswordRouteImport } from './routes/(auth)/reset-password'
import { Route as authSignInRouteImport } from './routes/(auth)/sign-in'
import { Route as errors401RouteImport } from './routes/(errors)/401'
import { Route as errors403RouteImport } from './routes/(errors)/403'
import { Route as errors404RouteImport } from './routes/(errors)/404'
import { Route as errors500RouteImport } from './routes/(errors)/500'
import { Route as errors503RouteImport } from './routes/(errors)/503'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedAiPromptsRouteImport } from './routes/_authenticated/ai-prompts'
import { Route as AuthenticatedCitiesRouteImport } from './routes/_authenticated/cities'
import { Route as AuthenticatedCustomersRouteImport } from './routes/_authenticated/customers'
import { Route as AuthenticatedDistancesRouteImport } from './routes/_authenticated/distances'
import { Route as AuthenticatedFaqsRouteImport } from './routes/_authenticated/faqs'
import { Route as AuthenticatedFeaturesRouteImport } from './routes/_authenticated/features'
import { Route as AuthenticatedProjectsRouteRouteImport } from './routes/_authenticated/projects/route'
import { Route as AuthenticatedStaffRouteImport } from './routes/_authenticated/staff'
import { Route as AuthenticatedBlogsIndexRouteImport } from './routes/_authenticated/blogs/index'
import { Route as AuthenticatedBlogsNewRouteImport } from './routes/_authenticated/blogs/new'
import { Route as AuthenticatedDistrictsIndexRouteImport } from './routes/_authenticated/districts/index'
import { Route as AuthenticatedDistrictsNewRouteImport } from './routes/_authenticated/districts/new'
import { Route as AuthenticatedErrorsErrorRouteImport } from './routes/_authenticated/errors/$error'
import { Route as AuthenticatedProjectsIndexRouteImport } from './routes/_authenticated/projects/index'
import { Route as AuthenticatedProjectsNewRouteImport } from './routes/_authenticated/projects/new'
import { Route as AuthenticatedUtilsFormRouteImport } from './routes/_authenticated/utils/form'
import { Route as AuthenticatedBlogsBlogIdUpdateRouteImport } from './routes/_authenticated/blogs/$blogId.update'
import { Route as AuthenticatedDistrictsDistrictIdUpdateRouteImport } from './routes/_authenticated/districts/$districtId.update'
import { Route as AuthenticatedProjectsProjectIdIndexRouteImport } from './routes/_authenticated/projects/$projectId/index'
import { Route as AuthenticatedProjectsProjectIdUpdateRouteImport } from './routes/_authenticated/projects/$projectId/update'
import { Route as AuthenticatedProjectsDraftsIndexRouteImport } from './routes/_authenticated/projects/drafts/index'
import { Route as AuthenticatedProjectsDraftsDraftIdRouteImport } from './routes/_authenticated/projects/drafts/$draftId'

const authRouteRoute = authRouteRouteImport.update({
  id: '/(auth)',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const authForgotPasswordRoute = authForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => authRouteRoute,
} as any)
const authResetPasswordRoute = authResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => authRouteRoute,
} as any)
const authSignInRoute = authSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => authRouteRoute,
} as any)
const errors401Route = errors401RouteImport.update({
  id: '/(errors)/401',
  path: '/401',
  getParentRoute: () => rootRouteImport,
} as any)
const errors403Route = errors403RouteImport.update({
  id: '/(errors)/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const errors404Route = errors404RouteImport.update({
  id: '/(errors)/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const errors500Route = errors500RouteImport.update({
  id: '/(errors)/500',
  path: '/500',
  getParentRoute: () => rootRouteImport,
} as any)
const errors503Route = errors503RouteImport.update({
  id: '/(errors)/503',
  path: '/503',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAiPromptsRoute = AuthenticatedAiPromptsRouteImport.update({
  id: '/ai-prompts',
  path: '/ai-prompts',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedCitiesRoute = AuthenticatedCitiesRouteImport.update({
  id: '/cities',
  path: '/cities',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedCustomersRoute = AuthenticatedCustomersRouteImport.update({
  id: '/customers',
  path: '/customers',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedDistancesRoute = AuthenticatedDistancesRouteImport.update({
  id: '/distances',
  path: '/distances',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedFaqsRoute = AuthenticatedFaqsRouteImport.update({
  id: '/faqs',
  path: '/faqs',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedFeaturesRoute = AuthenticatedFeaturesRouteImport.update({
  id: '/features',
  path: '/features',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedProjectsRouteRoute =
  AuthenticatedProjectsRouteRouteImport.update({
    id: '/projects',
    path: '/projects',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedStaffRoute = AuthenticatedStaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedBlogsIndexRoute = AuthenticatedBlogsIndexRouteImport.update({
  id: '/blogs/',
  path: '/blogs/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedBlogsNewRoute = AuthenticatedBlogsNewRouteImport.update({
  id: '/blogs/new',
  path: '/blogs/new',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedDistrictsIndexRoute =
  AuthenticatedDistrictsIndexRouteImport.update({
    id: '/districts/',
    path: '/districts/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDistrictsNewRoute =
  AuthenticatedDistrictsNewRouteImport.update({
    id: '/districts/new',
    path: '/districts/new',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedErrorsErrorRoute =
  AuthenticatedErrorsErrorRouteImport.update({
    id: '/errors/$error',
    path: '/errors/$error',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProjectsIndexRoute =
  AuthenticatedProjectsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedProjectsRouteRoute,
  } as any)
const AuthenticatedProjectsNewRoute =
  AuthenticatedProjectsNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AuthenticatedProjectsRouteRoute,
  } as any)
const AuthenticatedUtilsFormRoute = AuthenticatedUtilsFormRouteImport.update({
  id: '/utils/form',
  path: '/utils/form',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedBlogsBlogIdUpdateRoute =
  AuthenticatedBlogsBlogIdUpdateRouteImport.update({
    id: '/blogs/$blogId/update',
    path: '/blogs/$blogId/update',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDistrictsDistrictIdUpdateRoute =
  AuthenticatedDistrictsDistrictIdUpdateRouteImport.update({
    id: '/districts/$districtId/update',
    path: '/districts/$districtId/update',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProjectsProjectIdIndexRoute =
  AuthenticatedProjectsProjectIdIndexRouteImport.update({
    id: '/$projectId/',
    path: '/$projectId/',
    getParentRoute: () => AuthenticatedProjectsRouteRoute,
  } as any)
const AuthenticatedProjectsProjectIdUpdateRoute =
  AuthenticatedProjectsProjectIdUpdateRouteImport.update({
    id: '/$projectId/update',
    path: '/$projectId/update',
    getParentRoute: () => AuthenticatedProjectsRouteRoute,
  } as any)
const AuthenticatedProjectsDraftsIndexRoute =
  AuthenticatedProjectsDraftsIndexRouteImport.update({
    id: '/drafts/',
    path: '/drafts/',
    getParentRoute: () => AuthenticatedProjectsRouteRoute,
  } as any)
const AuthenticatedProjectsDraftsDraftIdRoute =
  AuthenticatedProjectsDraftsDraftIdRouteImport.update({
    id: '/drafts/$draftId',
    path: '/drafts/$draftId',
    getParentRoute: () => AuthenticatedProjectsRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/projects': typeof AuthenticatedProjectsRouteRouteWithChildren
  '/forgot-password': typeof authForgotPasswordRoute
  '/reset-password': typeof authResetPasswordRoute
  '/sign-in': typeof authSignInRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/ai-prompts': typeof AuthenticatedAiPromptsRoute
  '/cities': typeof AuthenticatedCitiesRoute
  '/customers': typeof AuthenticatedCustomersRoute
  '/distances': typeof AuthenticatedDistancesRoute
  '/faqs': typeof AuthenticatedFaqsRoute
  '/features': typeof AuthenticatedFeaturesRoute
  '/staff': typeof AuthenticatedStaffRoute
  '/blogs/new': typeof AuthenticatedBlogsNewRoute
  '/districts/new': typeof AuthenticatedDistrictsNewRoute
  '/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/projects/new': typeof AuthenticatedProjectsNewRoute
  '/utils/form': typeof AuthenticatedUtilsFormRoute
  '/blogs/': typeof AuthenticatedBlogsIndexRoute
  '/districts/': typeof AuthenticatedDistrictsIndexRoute
  '/projects/': typeof AuthenticatedProjectsIndexRoute
  '/blogs/$blogId/update': typeof AuthenticatedBlogsBlogIdUpdateRoute
  '/districts/$districtId/update': typeof AuthenticatedDistrictsDistrictIdUpdateRoute
  '/projects/$projectId/update': typeof AuthenticatedProjectsProjectIdUpdateRoute
  '/projects/drafts/$draftId': typeof AuthenticatedProjectsDraftsDraftIdRoute
  '/projects/$projectId/': typeof AuthenticatedProjectsProjectIdIndexRoute
  '/projects/drafts/': typeof AuthenticatedProjectsDraftsIndexRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof authForgotPasswordRoute
  '/reset-password': typeof authResetPasswordRoute
  '/sign-in': typeof authSignInRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/ai-prompts': typeof AuthenticatedAiPromptsRoute
  '/cities': typeof AuthenticatedCitiesRoute
  '/customers': typeof AuthenticatedCustomersRoute
  '/distances': typeof AuthenticatedDistancesRoute
  '/faqs': typeof AuthenticatedFaqsRoute
  '/features': typeof AuthenticatedFeaturesRoute
  '/staff': typeof AuthenticatedStaffRoute
  '/': typeof AuthenticatedIndexRoute
  '/blogs/new': typeof AuthenticatedBlogsNewRoute
  '/districts/new': typeof AuthenticatedDistrictsNewRoute
  '/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/projects/new': typeof AuthenticatedProjectsNewRoute
  '/utils/form': typeof AuthenticatedUtilsFormRoute
  '/blogs': typeof AuthenticatedBlogsIndexRoute
  '/districts': typeof AuthenticatedDistrictsIndexRoute
  '/projects': typeof AuthenticatedProjectsIndexRoute
  '/blogs/$blogId/update': typeof AuthenticatedBlogsBlogIdUpdateRoute
  '/districts/$districtId/update': typeof AuthenticatedDistrictsDistrictIdUpdateRoute
  '/projects/$projectId/update': typeof AuthenticatedProjectsProjectIdUpdateRoute
  '/projects/drafts/$draftId': typeof AuthenticatedProjectsDraftsDraftIdRoute
  '/projects/$projectId': typeof AuthenticatedProjectsProjectIdIndexRoute
  '/projects/drafts': typeof AuthenticatedProjectsDraftsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(auth)': typeof authRouteRouteWithChildren
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/_authenticated/projects': typeof AuthenticatedProjectsRouteRouteWithChildren
  '/(auth)/forgot-password': typeof authForgotPasswordRoute
  '/(auth)/reset-password': typeof authResetPasswordRoute
  '/(auth)/sign-in': typeof authSignInRoute
  '/(errors)/401': typeof errors401Route
  '/(errors)/403': typeof errors403Route
  '/(errors)/404': typeof errors404Route
  '/(errors)/500': typeof errors500Route
  '/(errors)/503': typeof errors503Route
  '/_authenticated/ai-prompts': typeof AuthenticatedAiPromptsRoute
  '/_authenticated/cities': typeof AuthenticatedCitiesRoute
  '/_authenticated/customers': typeof AuthenticatedCustomersRoute
  '/_authenticated/distances': typeof AuthenticatedDistancesRoute
  '/_authenticated/faqs': typeof AuthenticatedFaqsRoute
  '/_authenticated/features': typeof AuthenticatedFeaturesRoute
  '/_authenticated/staff': typeof AuthenticatedStaffRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/blogs/new': typeof AuthenticatedBlogsNewRoute
  '/_authenticated/districts/new': typeof AuthenticatedDistrictsNewRoute
  '/_authenticated/errors/$error': typeof AuthenticatedErrorsErrorRoute
  '/_authenticated/projects/new': typeof AuthenticatedProjectsNewRoute
  '/_authenticated/utils/form': typeof AuthenticatedUtilsFormRoute
  '/_authenticated/blogs/': typeof AuthenticatedBlogsIndexRoute
  '/_authenticated/districts/': typeof AuthenticatedDistrictsIndexRoute
  '/_authenticated/projects/': typeof AuthenticatedProjectsIndexRoute
  '/_authenticated/blogs/$blogId/update': typeof AuthenticatedBlogsBlogIdUpdateRoute
  '/_authenticated/districts/$districtId/update': typeof AuthenticatedDistrictsDistrictIdUpdateRoute
  '/_authenticated/projects/$projectId/update': typeof AuthenticatedProjectsProjectIdUpdateRoute
  '/_authenticated/projects/drafts/$draftId': typeof AuthenticatedProjectsDraftsDraftIdRoute
  '/_authenticated/projects/$projectId/': typeof AuthenticatedProjectsProjectIdIndexRoute
  '/_authenticated/projects/drafts/': typeof AuthenticatedProjectsDraftsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/projects'
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/ai-prompts'
    | '/cities'
    | '/customers'
    | '/distances'
    | '/faqs'
    | '/features'
    | '/staff'
    | '/blogs/new'
    | '/districts/new'
    | '/errors/$error'
    | '/projects/new'
    | '/utils/form'
    | '/blogs/'
    | '/districts/'
    | '/projects/'
    | '/blogs/$blogId/update'
    | '/districts/$districtId/update'
    | '/projects/$projectId/update'
    | '/projects/drafts/$draftId'
    | '/projects/$projectId/'
    | '/projects/drafts/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/reset-password'
    | '/sign-in'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/ai-prompts'
    | '/cities'
    | '/customers'
    | '/distances'
    | '/faqs'
    | '/features'
    | '/staff'
    | '/'
    | '/blogs/new'
    | '/districts/new'
    | '/errors/$error'
    | '/projects/new'
    | '/utils/form'
    | '/blogs'
    | '/districts'
    | '/projects'
    | '/blogs/$blogId/update'
    | '/districts/$districtId/update'
    | '/projects/$projectId/update'
    | '/projects/drafts/$draftId'
    | '/projects/$projectId'
    | '/projects/drafts'
  id:
    | '__root__'
    | '/(auth)'
    | '/_authenticated'
    | '/_authenticated/projects'
    | '/(auth)/forgot-password'
    | '/(auth)/reset-password'
    | '/(auth)/sign-in'
    | '/(errors)/401'
    | '/(errors)/403'
    | '/(errors)/404'
    | '/(errors)/500'
    | '/(errors)/503'
    | '/_authenticated/ai-prompts'
    | '/_authenticated/cities'
    | '/_authenticated/customers'
    | '/_authenticated/distances'
    | '/_authenticated/faqs'
    | '/_authenticated/features'
    | '/_authenticated/staff'
    | '/_authenticated/'
    | '/_authenticated/blogs/new'
    | '/_authenticated/districts/new'
    | '/_authenticated/errors/$error'
    | '/_authenticated/projects/new'
    | '/_authenticated/utils/form'
    | '/_authenticated/blogs/'
    | '/_authenticated/districts/'
    | '/_authenticated/projects/'
    | '/_authenticated/blogs/$blogId/update'
    | '/_authenticated/districts/$districtId/update'
    | '/_authenticated/projects/$projectId/update'
    | '/_authenticated/projects/drafts/$draftId'
    | '/_authenticated/projects/$projectId/'
    | '/_authenticated/projects/drafts/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  authRouteRoute: typeof authRouteRouteWithChildren
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  errors401Route: typeof errors401Route
  errors403Route: typeof errors403Route
  errors404Route: typeof errors404Route
  errors500Route: typeof errors500Route
  errors503Route: typeof errors503Route
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(auth)': {
      id: '/(auth)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof authRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/reset-password': {
      id: '/(auth)/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof authResetPasswordRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/sign-in': {
      id: '/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(errors)/401': {
      id: '/(errors)/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof errors401RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/403': {
      id: '/(errors)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof errors403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/404': {
      id: '/(errors)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof errors404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/500': {
      id: '/(errors)/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof errors500RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/503': {
      id: '/(errors)/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof errors503RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/ai-prompts': {
      id: '/_authenticated/ai-prompts'
      path: '/ai-prompts'
      fullPath: '/ai-prompts'
      preLoaderRoute: typeof AuthenticatedAiPromptsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/cities': {
      id: '/_authenticated/cities'
      path: '/cities'
      fullPath: '/cities'
      preLoaderRoute: typeof AuthenticatedCitiesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/customers': {
      id: '/_authenticated/customers'
      path: '/customers'
      fullPath: '/customers'
      preLoaderRoute: typeof AuthenticatedCustomersRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/distances': {
      id: '/_authenticated/distances'
      path: '/distances'
      fullPath: '/distances'
      preLoaderRoute: typeof AuthenticatedDistancesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/faqs': {
      id: '/_authenticated/faqs'
      path: '/faqs'
      fullPath: '/faqs'
      preLoaderRoute: typeof AuthenticatedFaqsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/features': {
      id: '/_authenticated/features'
      path: '/features'
      fullPath: '/features'
      preLoaderRoute: typeof AuthenticatedFeaturesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects': {
      id: '/_authenticated/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof AuthenticatedProjectsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/staff': {
      id: '/_authenticated/staff'
      path: '/staff'
      fullPath: '/staff'
      preLoaderRoute: typeof AuthenticatedStaffRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/blogs/': {
      id: '/_authenticated/blogs/'
      path: '/blogs'
      fullPath: '/blogs/'
      preLoaderRoute: typeof AuthenticatedBlogsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/blogs/new': {
      id: '/_authenticated/blogs/new'
      path: '/blogs/new'
      fullPath: '/blogs/new'
      preLoaderRoute: typeof AuthenticatedBlogsNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/districts/': {
      id: '/_authenticated/districts/'
      path: '/districts'
      fullPath: '/districts/'
      preLoaderRoute: typeof AuthenticatedDistrictsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/districts/new': {
      id: '/_authenticated/districts/new'
      path: '/districts/new'
      fullPath: '/districts/new'
      preLoaderRoute: typeof AuthenticatedDistrictsNewRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/errors/$error': {
      id: '/_authenticated/errors/$error'
      path: '/errors/$error'
      fullPath: '/errors/$error'
      preLoaderRoute: typeof AuthenticatedErrorsErrorRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/': {
      id: '/_authenticated/projects/'
      path: '/'
      fullPath: '/projects/'
      preLoaderRoute: typeof AuthenticatedProjectsIndexRouteImport
      parentRoute: typeof AuthenticatedProjectsRouteRoute
    }
    '/_authenticated/projects/new': {
      id: '/_authenticated/projects/new'
      path: '/new'
      fullPath: '/projects/new'
      preLoaderRoute: typeof AuthenticatedProjectsNewRouteImport
      parentRoute: typeof AuthenticatedProjectsRouteRoute
    }
    '/_authenticated/utils/form': {
      id: '/_authenticated/utils/form'
      path: '/utils/form'
      fullPath: '/utils/form'
      preLoaderRoute: typeof AuthenticatedUtilsFormRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/blogs/$blogId/update': {
      id: '/_authenticated/blogs/$blogId/update'
      path: '/blogs/$blogId/update'
      fullPath: '/blogs/$blogId/update'
      preLoaderRoute: typeof AuthenticatedBlogsBlogIdUpdateRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/districts/$districtId/update': {
      id: '/_authenticated/districts/$districtId/update'
      path: '/districts/$districtId/update'
      fullPath: '/districts/$districtId/update'
      preLoaderRoute: typeof AuthenticatedDistrictsDistrictIdUpdateRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/projects/$projectId/': {
      id: '/_authenticated/projects/$projectId/'
      path: '/$projectId'
      fullPath: '/projects/$projectId/'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdIndexRouteImport
      parentRoute: typeof AuthenticatedProjectsRouteRoute
    }
    '/_authenticated/projects/$projectId/update': {
      id: '/_authenticated/projects/$projectId/update'
      path: '/$projectId/update'
      fullPath: '/projects/$projectId/update'
      preLoaderRoute: typeof AuthenticatedProjectsProjectIdUpdateRouteImport
      parentRoute: typeof AuthenticatedProjectsRouteRoute
    }
    '/_authenticated/projects/drafts/': {
      id: '/_authenticated/projects/drafts/'
      path: '/drafts'
      fullPath: '/projects/drafts/'
      preLoaderRoute: typeof AuthenticatedProjectsDraftsIndexRouteImport
      parentRoute: typeof AuthenticatedProjectsRouteRoute
    }
    '/_authenticated/projects/drafts/$draftId': {
      id: '/_authenticated/projects/drafts/$draftId'
      path: '/drafts/$draftId'
      fullPath: '/projects/drafts/$draftId'
      preLoaderRoute: typeof AuthenticatedProjectsDraftsDraftIdRouteImport
      parentRoute: typeof AuthenticatedProjectsRouteRoute
    }
  }
}

interface authRouteRouteChildren {
  authForgotPasswordRoute: typeof authForgotPasswordRoute
  authResetPasswordRoute: typeof authResetPasswordRoute
  authSignInRoute: typeof authSignInRoute
}

const authRouteRouteChildren: authRouteRouteChildren = {
  authForgotPasswordRoute: authForgotPasswordRoute,
  authResetPasswordRoute: authResetPasswordRoute,
  authSignInRoute: authSignInRoute,
}

const authRouteRouteWithChildren = authRouteRoute._addFileChildren(
  authRouteRouteChildren,
)

interface AuthenticatedProjectsRouteRouteChildren {
  AuthenticatedProjectsNewRoute: typeof AuthenticatedProjectsNewRoute
  AuthenticatedProjectsIndexRoute: typeof AuthenticatedProjectsIndexRoute
  AuthenticatedProjectsProjectIdUpdateRoute: typeof AuthenticatedProjectsProjectIdUpdateRoute
  AuthenticatedProjectsDraftsDraftIdRoute: typeof AuthenticatedProjectsDraftsDraftIdRoute
  AuthenticatedProjectsProjectIdIndexRoute: typeof AuthenticatedProjectsProjectIdIndexRoute
  AuthenticatedProjectsDraftsIndexRoute: typeof AuthenticatedProjectsDraftsIndexRoute
}

const AuthenticatedProjectsRouteRouteChildren: AuthenticatedProjectsRouteRouteChildren =
  {
    AuthenticatedProjectsNewRoute: AuthenticatedProjectsNewRoute,
    AuthenticatedProjectsIndexRoute: AuthenticatedProjectsIndexRoute,
    AuthenticatedProjectsProjectIdUpdateRoute:
      AuthenticatedProjectsProjectIdUpdateRoute,
    AuthenticatedProjectsDraftsDraftIdRoute:
      AuthenticatedProjectsDraftsDraftIdRoute,
    AuthenticatedProjectsProjectIdIndexRoute:
      AuthenticatedProjectsProjectIdIndexRoute,
    AuthenticatedProjectsDraftsIndexRoute:
      AuthenticatedProjectsDraftsIndexRoute,
  }

const AuthenticatedProjectsRouteRouteWithChildren =
  AuthenticatedProjectsRouteRoute._addFileChildren(
    AuthenticatedProjectsRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedProjectsRouteRoute: typeof AuthenticatedProjectsRouteRouteWithChildren
  AuthenticatedAiPromptsRoute: typeof AuthenticatedAiPromptsRoute
  AuthenticatedCitiesRoute: typeof AuthenticatedCitiesRoute
  AuthenticatedCustomersRoute: typeof AuthenticatedCustomersRoute
  AuthenticatedDistancesRoute: typeof AuthenticatedDistancesRoute
  AuthenticatedFaqsRoute: typeof AuthenticatedFaqsRoute
  AuthenticatedFeaturesRoute: typeof AuthenticatedFeaturesRoute
  AuthenticatedStaffRoute: typeof AuthenticatedStaffRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedBlogsNewRoute: typeof AuthenticatedBlogsNewRoute
  AuthenticatedDistrictsNewRoute: typeof AuthenticatedDistrictsNewRoute
  AuthenticatedErrorsErrorRoute: typeof AuthenticatedErrorsErrorRoute
  AuthenticatedUtilsFormRoute: typeof AuthenticatedUtilsFormRoute
  AuthenticatedBlogsIndexRoute: typeof AuthenticatedBlogsIndexRoute
  AuthenticatedDistrictsIndexRoute: typeof AuthenticatedDistrictsIndexRoute
  AuthenticatedBlogsBlogIdUpdateRoute: typeof AuthenticatedBlogsBlogIdUpdateRoute
  AuthenticatedDistrictsDistrictIdUpdateRoute: typeof AuthenticatedDistrictsDistrictIdUpdateRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedProjectsRouteRoute: AuthenticatedProjectsRouteRouteWithChildren,
  AuthenticatedAiPromptsRoute: AuthenticatedAiPromptsRoute,
  AuthenticatedCitiesRoute: AuthenticatedCitiesRoute,
  AuthenticatedCustomersRoute: AuthenticatedCustomersRoute,
  AuthenticatedDistancesRoute: AuthenticatedDistancesRoute,
  AuthenticatedFaqsRoute: AuthenticatedFaqsRoute,
  AuthenticatedFeaturesRoute: AuthenticatedFeaturesRoute,
  AuthenticatedStaffRoute: AuthenticatedStaffRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedBlogsNewRoute: AuthenticatedBlogsNewRoute,
  AuthenticatedDistrictsNewRoute: AuthenticatedDistrictsNewRoute,
  AuthenticatedErrorsErrorRoute: AuthenticatedErrorsErrorRoute,
  AuthenticatedUtilsFormRoute: AuthenticatedUtilsFormRoute,
  AuthenticatedBlogsIndexRoute: AuthenticatedBlogsIndexRoute,
  AuthenticatedDistrictsIndexRoute: AuthenticatedDistrictsIndexRoute,
  AuthenticatedBlogsBlogIdUpdateRoute: AuthenticatedBlogsBlogIdUpdateRoute,
  AuthenticatedDistrictsDistrictIdUpdateRoute:
    AuthenticatedDistrictsDistrictIdUpdateRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  authRouteRoute: authRouteRouteWithChildren,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  errors401Route: errors401Route,
  errors403Route: errors403Route,
  errors404Route: errors404Route,
  errors500Route: errors500Route,
  errors503Route: errors503Route,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
